import './_DataFeedModal.scss';
import { Modal } from 'react-bootstrap';
import { IConfirmDeleteFeedModal } from '../types/IDataFeedModal';
import Button from '../../../../ntisui/Atoms/Buttons';
import { ButtonVariant } from '../../../template/types/IHeader';
import { litrals } from '../../../../../constants/Litrals';

const ConfirmDataModal = (props: IConfirmDeleteFeedModal) => {
  return (
    <Modal
      contentClassName="modal-subscription-confirmation"
      show={props.show}
      onHide={() => props.onClose()}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{props.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{props.content}</Modal.Body>
      <Modal.Footer>
        <Button
          variant={ButtonVariant.Primary}
          className="confirm-button"
          label={litrals.cancelSubscription}
          ariaLabel="cancelSubscriptionButton"
          onClick={() => {
            props.onConfirm();
          }}
        />
      </Modal.Footer>
    </Modal>
  );
};
export default ConfirmDataModal;
